import React, { useState, useEffect } from 'react';
import { config } from '../../config';
import { handleResponse } from '../../helpers/response';
import { Link } from 'react-router-dom';
import i18n from '../../i18n';
import { useTranslation, withTranslation } from 'react-i18next';
import defImage from '../../images/not-image.png';
import Footer from '../footer';
import { Helmet } from 'react-helmet';

const SubMenu = (props) => {
  const catId = props.match.params.catId;
  const [listLinks, setListLinks] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  useEffect(() => {
    const link =
      config.apiUrl +
      'api/get/custommenu/submenu/' +
      catId +
      '/' +
      i18n.language;
    fetch(link, { method: 'GET' })
      .then(handleResponse)
      .then((json) => {
        if (Object.keys(json).length > 0) {
          setListLinks(json);
          setCategoryName(json[Object.keys(json)[0]]['filterName']);
        }
      })
      .catch((error) => {
        alert('error');
      });
  }, []);
  const { t } = useTranslation();

  return (
    <>
      <header>
        <Helmet>
          <title>{t('brand.title')}</title>
          {/* <title>{categoryName}</title> */}
        </Helmet>
      </header>
      <div className='uk-container'>
        <div className='uk-margin-top '>
          <h1 className='page-title uk-text-bold'>{categoryName}</h1>
          <div
            className='uk-child-width-1-3@s uk-child-width-1-5@m uk-child-width-1-2 uk-grid-match'
            uk-grid=''
          >
            {Object.keys(listLinks).map((itm) => {
              return (
                <div key={`listLink_${itm}`}>
                  <div className='category-card uk-card uk-card-small'>
                    <div className='uk-card-header'>
                      <Link
                        to={`/products/${i18n.language}/custom/${listLinks[itm].alias}`}
                      >
                        <img
                          className='category-card__img'
                          src={
                            config.assetsPrfix +
                            'img/products/min_' +
                            listLinks[itm].image
                              ? config.assetsPrfix +
                                'img/products/min_' +
                                listLinks[itm].image
                              : defImage
                          }
                          alt={listLinks[itm].name}
                        />
                      </Link>
                    </div>
                    <div className='uk-card-body'>
                      <Link
                        className='category-card__title'
                        to={`/products/${i18n.language}/custom/${listLinks[itm].alias}`}
                      >
                        {listLinks[itm].name}
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default withTranslation('translations')(SubMenu);
